// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle-btn * {
    -webkit-text-decoration: none;
    text-decoration: none;
  }

.toggle-btn button.icon-toggle-btn.highlight {
      background-color: var(--btn-bg-color);
      border: 1px solid var(--border-dark-color);
      color: var(--white);
    }

.toggle-btn button.icon-toggle-btn.highlight:hover {
        background-color: var(--btn-dark-bg-color);
        border: 1px solid var(--border-dark-bg-color);
      }

.toggle-btn button.icon-toggle-btn {
      background-color: var(--white);
      border: 1px solid var(--border-dark-color);
      color: var(--black);
      font-size: 1rem;
      padding: 0.25rem 0.5rem;
      cursor: pointer;
      display: flex;
    }

.toggle-btn button.icon-toggle-btn:hover {
        background-color: var(--grey2);
      }

.toggle-btn .icon-toggle-btn .icon-toggle-btn-icon {
      display: inline-flex;
      align-items: center;
    }

@media (min-width: 48.001rem) {
      .toggle-btn .icon-toggle-btn.lg-icon-hide .icon-toggle-btn-icon {
        display: none;
      }

      .toggle-btn .icon-toggle-btn.lg-label-hide .icon-toggle-btn-label {
        display: none;
      }

      .toggle-btn .icon-toggle-btn.lg-custom-hide .icon-toggle-btn-custom {
        display: none;
      }
        .toggle-btn .icon-toggle-btn.lg-icon-hide .icon-toggle-btn-icon + .icon-toggle-btn-label {
          margin-left: 0rem;
        }

      .toggle-btn .icon-toggle-btn .icon-toggle-btn-icon + .icon-toggle-btn-label {
        margin-left: 0.5rem;
      }
    }

@media (max-width: 48rem) {
      .toggle-btn .icon-toggle-btn.sm-icon-hide .icon-toggle-btn-icon {
        display: none;
      }

      .toggle-btn .icon-toggle-btn.sm-label-hide .icon-toggle-btn-label {
        display: none;
      }

      .toggle-btn .icon-toggle-btn.sm-custom-hide .icon-toggle-btn-custom {
        display: none;
      }
        .toggle-btn .icon-toggle-btn.sm-icon-hide .icon-toggle-btn-icon + .icon-toggle-btn-label {
          margin-left: 0rem;
        }

      .toggle-btn .icon-toggle-btn .icon-toggle-btn-icon + .icon-toggle-btn-label {
        margin-left: 0.5rem;
      }
    }
`, "",{"version":3,"sources":["webpack://./core/components/IconToggleButton.css"],"names":[],"mappings":"AAGE;IACE,6BAAqB;IAArB,qBAAqB;EACvB;;AAIE;MACE,qCAAqC;MACrC,0CAA0C;MAC1C,mBAAmB;IAMrB;;AAJE;QACE,0CAA0C;QAC1C,6CAA6C;MAC/C;;AAGF;MACE,8BAA8B;MAC9B,0CAA0C;MAC1C,mBAAmB;MACnB,eAAe;MACf,uBAAuB;MACvB,eAAe;MACf,aAAa;IAKf;;AAHE;QACE,8BAA8B;MAChC;;AAIF;MACE,oBAAoB;MACpB,mBAAmB;IACrB;;AAEA;MACE;QACE,aAAa;MACf;;MAEA;QACE,aAAa;MACf;;MAEA;QACE,aAAa;MACf;QAGE;UACE,iBAAiB;QACnB;;MAIF;QACE,mBAAmB;MACrB;IACF;;AAEA;MACE;QACE,aAAa;MACf;;MAEA;QACE,aAAa;MACf;;MAEA;QACE,aAAa;MACf;QAGE;UACE,iBAAiB;QACnB;;MAGF;QACE,mBAAmB;MACrB;IACF","sourcesContent":["@import \"shared.css\";\r\n\r\n.toggle-btn {\r\n  * {\r\n    text-decoration: none;\r\n  }\r\n\r\n  .icon-toggle-btn {\r\n\r\n    &button.highlight {\r\n      background-color: var(--btn-bg-color);\r\n      border: 1px solid var(--border-dark-color);\r\n      color: var(--white);\r\n\r\n      &:hover {\r\n        background-color: var(--btn-dark-bg-color);\r\n        border: 1px solid var(--border-dark-bg-color);\r\n      }\r\n    }\r\n\r\n    &button {\r\n      background-color: var(--white);\r\n      border: 1px solid var(--border-dark-color);\r\n      color: var(--black);\r\n      font-size: 1rem;\r\n      padding: 0.25rem 0.5rem;\r\n      cursor: pointer;\r\n      display: flex;\r\n\r\n      &:hover {\r\n        background-color: var(--grey2);\r\n      }\r\n    }\r\n\r\n\r\n    .icon-toggle-btn-icon {\r\n      display: inline-flex;\r\n      align-items: center;\r\n    }\r\n\r\n    @media (width > 48rem) {\r\n      &.lg-icon-hide .icon-toggle-btn-icon {\r\n        display: none;\r\n      }\r\n\r\n      &.lg-label-hide .icon-toggle-btn-label {\r\n        display: none;\r\n      }\r\n\r\n      &.lg-custom-hide .icon-toggle-btn-custom {\r\n        display: none;\r\n      }\r\n\r\n      &.lg-icon-hide {\r\n        .icon-toggle-btn-icon+.icon-toggle-btn-label {\r\n          margin-left: 0rem;\r\n        }\r\n\r\n      }\r\n\r\n      .icon-toggle-btn-icon+.icon-toggle-btn-label {\r\n        margin-left: 0.5rem;\r\n      }\r\n    }\r\n\r\n    @media (max-width: 48rem) {\r\n      &.sm-icon-hide .icon-toggle-btn-icon {\r\n        display: none;\r\n      }\r\n\r\n      &.sm-label-hide .icon-toggle-btn-label {\r\n        display: none;\r\n      }\r\n\r\n      &.sm-custom-hide .icon-toggle-btn-custom {\r\n        display: none;\r\n      }\r\n\r\n      &.sm-icon-hide {\r\n        .icon-toggle-btn-icon+.icon-toggle-btn-label {\r\n          margin-left: 0rem;\r\n        }\r\n      }\r\n\r\n      .icon-toggle-btn-icon+.icon-toggle-btn-label {\r\n        margin-left: 0.5rem;\r\n      }\r\n    }\r\n\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
